// ============================================================================
// INITIAL STATE - visualCircuitInitialState.js
// ============================================================================
// ./context/visualCircuit/visualCircuitInitialState.js

export default {
    circuits: [],
    currentCircuit: null,
    templates: [],
    studentCircuits: [],
    enrolledUsers: [],
    labCircuits: [],
    courseCircuits: [],
    statistics: null,
    isLoading: false,
    validationResult: null,
    error: null
}